/**
 * home-user-list コンポーネント専用i18n定数
 */

export const HOME_USER_LIST_I18N = {
  // パンくずリスト
  breadcrumb: {
    userList: $localize`:@@home.userList.breadcrumb.userList:ユーザー一覧`,
  },
} as const;

export type HomeUserListI18n = typeof HOME_USER_LIST_I18N;
